interface TemplateStringProps {
  template: string;
  values: Record<string, string | number>;
}

export function TemplateString({
  values,
  template
}: TemplateStringProps): JSX.Element {
  const text = Object.entries(values ?? {}).reduce((acc, [key, value]) => {
    const expr = new RegExp(`{${key}}`, 'g');
    return acc.replace(expr, `${value}`);
  }, template);

  return <span dangerouslySetInnerHTML={{ __html: text }} />;
}
